import Dexie, { type EntityTable } from 'dexie'

export interface PendingEvent {
  id: number
  type: 'start' | 'end'
  clientEventId: string
  payload: { lat: number; lng: number; accuracyM: number }
  /**
   * Czas KLIKNIĘCIA na urządzeniu (epoch ms). Wysyłany do backendu jako
   * `occurredAt`, żeby zdarzenie zapisane offline o 8:00 i zsynchronizowane
   * o 12:00 nie wylądowało w bazie jako 12:00.
   */
  occurredAt: number
  createdAt: number
  attempts: number
  lastAttemptAt: number | null
  lastError: string | null
  /**
   * Zdarzenie trwale odrzucone przez backend (400/409). NIE usuwamy go z bazy —
   * to jedyny ślad po kliknięciu pracownika (godzina + GPS) i admin może
   * potrzebować go do ręcznej korekty. Wypada natomiast z kolejki wysyłkowej
   * i z licznika „synchronizuję N", żeby nie blokowało zdarzeń za sobą.
   */
  deadAt: number | null
  deadReason: string | null
}

export const db = new Dexie('czas-dental') as Dexie & {
  pendingEvents: EntityTable<PendingEvent, 'id'>
}

db.version(1).stores({
  pendingEvents: '++id, clientEventId, createdAt, type',
})

// v2: `occurredAt` (czas kliknięcia) + oznaczenie trwale odrzuconych zdarzeń.
// Dla wpisów sprzed migracji `occurredAt` = `createdAt` — to i tak był moment
// kliknięcia, po prostu nie był wtedy wysyłany do backendu.
db.version(2)
  .stores({
    pendingEvents: '++id, clientEventId, createdAt, type',
  })
  .upgrade((tx) =>
    tx
      .table<PendingEvent>('pendingEvents')
      .toCollection()
      .modify((event) => {
        if (event.occurredAt === undefined) {
          event.occurredAt = event.createdAt
        }
        if (event.deadAt === undefined) {
          event.deadAt = null
          event.deadReason = null
        }
      }),
  )

/** Zdarzenia czekające na wysyłkę — bez trwale odrzuconych. */
export function livePendingEvents() {
  return db.pendingEvents.filter((e) => e.deadAt === null)
}
